import {
  APPROVE_LEAD_VAULT_ACCESS,
  REVOKE_LEAD_VAULT_ACCESS,
  BLOCK_LEAD_VAULT_ACCESS,
  UNBLOCK_LEAD_VAULT_ACCESS,
  UPDATE_LEAD
} from '../../../../project/actions';
import { SET_RECORDS, RETRIEVE_RECORDS_FAILED, RETRIEVE_RECORDS_STARTED } from '../actions/search';

import leadsReducer from './leads';

export default function (state = {}, action) {
  switch (action.type) {
  case UPDATE_LEAD: {
    const updatedLead = action.payload;
    const leads = state.leads.map(lead => lead.id === updatedLead.id ? { ...lead, ...updatedLead } : { ...lead });
    return { ...state, leads };
  }
  case SET_RECORDS: {
    const { leads, meta } = action;
    return { ...state, isFetching: false, leads, loadFailed: false, meta };
  }
  case RETRIEVE_RECORDS_FAILED:
    return { ...state, isFetching: false, loadFailed: true };
  case RETRIEVE_RECORDS_STARTED: {
    const changes = { isFetching: true };
    if (action.abortController) changes.abortController = action.abortController;

    return { ...state, ...changes };
  }
  case APPROVE_LEAD_VAULT_ACCESS:
  case REVOKE_LEAD_VAULT_ACCESS:
  case BLOCK_LEAD_VAULT_ACCESS:
  case UNBLOCK_LEAD_VAULT_ACCESS: {
    return { ...state, leads: leadsReducer(state.leads, action) };
  }
  default:
    return state;
  }
}
